import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { INVOICE_CODE } from "../apiRoutes";

// Define the expected response type (adjust based on your API response)
export interface InvoiceCode {
  id: string;
  name: string;
  description: string;
  createdAt: string;
  isActive: boolean;
}

export interface InvoiceCodesResponse {
  data: {
    records: InvoiceCode[];
    pagination: { totalRecords: number }[];
  }[];
}

const fetchInvoiceCodes = async ({ data }: { data: FieldValues }) => {
  const response = await axiosAuth.get<InvoiceCodesResponse>(INVOICE_CODE, {
    params: data,
  });
  return response.data;
};

// Query hook
const useInvoiceCodesQuery = (
  data: FieldValues,
  queryParams?: Omit<
    UseQueryOptions<
      InvoiceCodesResponse,
      Error,
      InvoiceCodesResponse,
      ["invoiceCodes", FieldValues]
    >,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<
    InvoiceCodesResponse,
    Error,
    InvoiceCodesResponse,
    ["invoiceCodes", FieldValues]
  >({
    queryKey: ["invoiceCodes", data],
    queryFn: () => fetchInvoiceCodes({ data }),
    ...(queryParams || {}),
  });

export default useInvoiceCodesQuery;
